// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"3a4b98a3","184":"5d6183f4","340":"54b90397","405":"ac49d899","591":"cb7c93bd","787":"7c3df9de","815":"b883750c"}[chunkId] + ".chunk.js";
};